<template>
    <div id="app" :class="[brand]">
        <Loader v-show="isLoading"></Loader>
        <div v-show="(!isLoading)" class="container">
            <div class="main">
                <Nav class="nav-bar" ref="navBar" :brand="brand" :activeConfig.sync="activeConfig"
                     :active-content.sync="activeContent" v-if="(mainMod != 'hide')"/>
                <div class="content-col"
                     v-bind:style="[(mainMod != 'hide') ? {'width':'calc(100% - 285px)'}:{'width':'100%','border-radius':'12px 12px 0px 0px'}]">
                    <Header :brand="brand" :active-content.sync="activeContent" :user-agent="userAgent"></Header>
                    <Contents ref="contents" :brand="brand" :default-extensions="defaultExtensions"
                              :extensions.sync="extensions"
                              :activeContent="activeContent"
                              :url="url"
                              :domain="domain"
                              :user-agent="userAgent"></Contents>
                </div>
                <Footer/>
            </div>
        </div>
    </div>
</template>

<script>
    import Nav from './components/Nav.vue'
    import Footer from './components/Footer.vue'
    import Contents from './components/Content'
    import Header from './components/Header'
    import safelyConfig from './assets/brands/safely/config/config';
    import privatelyConfig from './assets/brands/privately/config/config';
    import onlinetoolsConfig from './assets/brands/onlinetools/config/config';

    export default {
        name: 'app',
        props: ['brand', 'defaultExtensions', 'userAgent', 'isOpen', 'yid'],
        data: function () {
            return {
                activeConfig: {},
                mainMod: "full",
                isLoading: true,
                activeContent: [],
                extensions: [],
                safelyConfig: safelyConfig,
                privatelyConfig: privatelyConfig,
                onlinetoolsConfig: onlinetoolsConfig,
                url: '',
                domain: ''
            }
        },
        components: {
            Nav, Footer, Contents, Header
        },
        mounted() {
            this.url = new URL(window.location.href);
            this.domain = this.url.host.replace('www.', '');

            /* set active config by brand */
            this.activeConfig = this[this.brand + 'Config'];

            /* set not configs to null */
            this.privatelyConfig = null;
            this.safelyConfig = null;
            this.onlinetoolsConfig = null;

            /* init title and favicon */
            document.title = this.activeConfig.title;
            document.querySelector("link[rel*='icon']").href = this.activeConfig.favicon;

            /* get installed extensions or legacy extensions*/
            this.$axios.get('//www.dsdashboardapi.com/api/index.php?action=ecr', {
                withCredentials: true
            }).then((result) => {
                return this.extensionsFormatter(result.data);
            }).then(() => {
                if (this.isOpen) {
                    let content = this.findExtensionDomainMap(this.activeConfig.content, this.isOpen);
                    this.activeContentChange(content.id, content.type);
                    this.$refs.navBar.openNav(content.type);
                }

                if (this.yid) {
                    this.checkIfHideIsNeeded(this.yid)
                }
            }).then(() => {
                this.isLoading = false;
            });
        },
        methods: {
            checkIfHideIsNeeded: function (yid) {
                let vm = this;
                this.$axios.get(`//www.dsdashboardapi.com/api/index.php?action=hide&yid=${yid}`, {withCredentials: true})
                    .then(function (response) {
                        response.json().then(function (res) {
                            if (res) {
                                vm.mainMod = 'hide';
                            }
                        });
                    });
            },
            findExtensionDomainMap: function (config, value) {
                let key = Object.keys(config).find(function (key) {
                    if (config[key]['extension_domain_map'] instanceof Array) {
                        for (let i = 0; i < config[key]['extension_domain_map'].length; i++) {
                            return config[key]['extension_domain_map'][i] == value;
                        }
                    } else {
                        return config[key]['extension_domain_map'] == value;
                    }
                });
                let res = config[key];
                res.id = key;
                return res;
            },
            isInstalledByType: function (extensionsType) {
                if (this.extensions.length > 0) {
                    if (this.extensions[0].installed == undefined) {
                        return false;
                    }
                    let extensions_filtered = this.extensions.filter(function (extension) {
                        return (extension.type == extensionsType);
                    });

                    if (extensions_filtered.length == 1) {
                        return extensions_filtered[0].installed;
                    }
                    return false;
                }
            }, findExtensionByType: function (extensionsType) {
                if (this.extensions[0].installed == undefined) {
                    return false;
                }

                return this.extensions.filter(function (extension) {
                    return (extension.type == extensionsType);
                })[0];
            }, activeContentChange: function (content, contentType, sub_open = null) {
                if (content == 'clear') {
                    this.activeContent = [];
                    this.$refs.navBar.closeAllNav();
                    return;
                }

                this.activeContent = this.activeConfig.content[content];
                this.activeContent.id = content;
                this.activeContent.not_install_icon = this.activeConfig.not_install_icon;
                this.activeContent.type = contentType; //data,private etc..
                this.activeContent.subOpen = sub_open;
                this.activeContent.__ob__.dep.notify();
            }, extensionsFormatter: function (extensions_data) {
                this.extensions = [];
                let vm = this;
                for (let key in extensions_data) {
                    if (extensions_data[key] instanceof Array) {
                        extensions_data[key].forEach(function (entry) {
                            let extension = {
                                id: entry,
                                type: key,
                                legacy: true
                            };
                            vm.extensions.push(extension);
                            vm.extensionExists(extension);
                        });
                    } else {
                        let extension = {
                            id: extensions_data[key],
                            type: key,
                            legacy: false
                        };
                        vm.extensions.push(extension);
                        vm.extensionExists(extension);
                    }
                }
            }, extensionExists: function (extension) {
                let vm = this;
                new Promise(function (resolve) {
                    let img = new Image();

                    if (vm.userAgent.browser.name == "Chrome") {
                        img.src = "chrome-extension://" + extension.id + "/img/icon16.png";
                    } else {
                        img.src = "moz-extension://" + extension.id + "/img/icon16.png";
                    }

                    img.onload = function () {
                        extension.installed = true;
                        resolve(extension);
                    };
                    img.onerror = function () {
                        extension.installed = false;
                        resolve(extension);
                    };
                }).then((extension) => {
                    vm.extensions.find(extension_bind => extension_bind.id == extension.id).installed = extension.installed;
                    return extension;
                }).then((extension) => {
                    vm.extensionRegUnreg(extension);
                }).then(() => {
                    vm.activeContent.__ob__.dep.notify(); //trigger watch for update if extension is install
                });
            }, extensionRegUnreg: function (extension) {
                let vm = this;
                if (extension.installed) {
                    if (extension.type === 'pdf') {
                        if (vm.url.searchParams.get('link')) {
                            vm.extensions.find(extension_bind => extension_bind.id == extension.id).extraParam = '?link=' + vm.url.searchParams.get('link');
                        } else if (vm.url.searchParams.get('linkDirect')) {
                            vm.extensions.find(extension_bind => extension_bind.id == extension.id).extraParam = '?link=' + vm.url.searchParams.get('linkDirect');
                        }
                    }

                    if (extension.legacy) {
                        vm.$axios.get('//www.dsdashboardapi.com/api/index.php?action=register&type=' + extension.type + '&id=' + extension.id, {withCredentials: true});
                    }
                } else if (!extension.legacy) {
                    vm.$axios.get('//www.dsdashboardapi.com/api/index.php?action=unregister&type=' + extension.type, {withCredentials: true});
                }
            },
            installExtension: function (extensionsType) {
                let id = this.defaultExtensions[extensionsType];
                window.open('https://chrome.google.com/webstore/detail/' + id, 'https://chrome.google.com/webstore/detail/' + id, "toolbar=no,scrollbars=yes,resizable=yes,width=" + screen.availWidth + ",height=" + screen.availHeight + "");
            }
        }
    }
</script>
<style>
    @import "assets/css/fontawesome-all.min.css";

    * {
        box-sizing: border-box;
        margin: 0;
        padding: 0;
    }

    html, body, .container {
        min-height: 100%;
        height: 100%;
    }

    body {
        font-family: 'Roboto', sans-serif;
        --main-svg-color: #5C5C5C;
        --secondary-svg-color: #8A8A8A;
        background: #f4f3f3;
        color: #4a4b4b;
        overflow-x: hidden;
    }

    h3 {
        font-size: 24px;
    }

    .container {
        width: 1230px;
        max-width: 100%;
        margin: 0 auto;
        min-height: 100vh;
        display: flex;
        align-items: center;
    }

    .main {
        width: 100%;
        display: flex;
        border: solid 1px #e2e2e2;
        background: #fff;
        box-shadow: 0 5px 80px 0 rgba(0, 0, 0, 0.1);
        height: calc(100vh - 75px);
        max-height: 800px;
        margin-top: -30px;
        position: relative;
    }

    .nav-bar {
        width: 285px;
    }

    /*
    ************************
      btn
    **************************
    */

    .extension-action-wrapper.text-box-button .btn {
        width: 140px;
    }

    .extension-action-wrapper.text-right {
        text-align: right;
    }

    .extension-action-wrapper .btn {
        width: 100%;
    }

    .tab-content .btn, .btn {
        font-size: 14px;
        color: #fff;
        border-radius: 4px;
        display: inline-block;
        text-decoration: none;
        text-align: center;
        font-weight: 500;
        padding: 12px 10px;
        transition: all .3s;
        border: 2px solid transparent;
    }

    .btn.btn-md {
        min-width: 140px;
    }

    .btn.btn-lg {
        min-width: 170px;
        padding: 10px 35px;
        font-size: 16px;
    }

    .btn.details-btn {
        padding: 8px 10px 8px 20px;
        text-align: left;
        position: relative;
    }

    .btn.details-btn .corner-arrow {
        position: absolute;
        width: 12px;
        height: 12px;
        border-top: 3px solid #fff;
        border-right: 3px solid #fff;
        right: 15px;
        transform: rotate(45deg);
        top: 50%;
        margin-top: -6px;
    }

    .btn.details-btn.showed .corner-arrow {
        transform: rotate(-45deg);
        margin-top: -4px;
    }

    .btn.default-btn:hover .corner-arrow {
        border-color: #D3D3D3;
    }

    .btn.details-btn .details-text {
        font-size: 16px;
    }

    .btn.gray-btn {
        background-color: #f7f8f9;
        border-color: #ebedf0;
        color: #565757;
    }

    .btn.gray-btn:hover {
        background-color: #fff;
    }

    .btn.default-btn {
        background-color: #D3D3D3;
    }

    .btn.default-btn:hover {
        color: #D3D3D3;
        border-color: #D3D3D3;
        background-color: #696969;
    }

    .btn.btn-reverse {
        background: #696969;
        color: #D3D3D3;
    }

    .btn.btn-reverse:hover {
        color: #696969;
        border-color: #696969;
        background-color: #D3D3D3;
    }

    .details-table .btn {
        padding: 8px 10px;
    }

    .btn.checked-btn {
        background-color: #696969;
    }

    .btn.checked-btn:hover {
        color: #696969;
        border-color: #696969;
        background-color: #D3D3D3;
    }

    .content-col {
        width: calc(100% - 285px);
    }

    .content-col {
        display: flex;
        flex-direction: column;
        overflow: hidden;
    }

    .content-col > .tab-item.active-tab {
        display: flex;
        flex-direction: column;
    }


    /*
    *****************************
        privately
    *****************************
    */
    .privately body {
        --theme-color: #1fb58f;
    }

    .privately > div.container > .main {
        border-radius: 12px;
    }

    .privately .btn.checked-btn {
        background-color: #00ccad;
    }

    .privately .btn.checked-btn:hover {
        color: #00ccad;
        border-color: #00ccad;
        background-color: #fff;
    }

    .privately .btn.default-btn {
        background-color: #fff;
        color: #00ccad;
        border-color: #00ccad;
    }

    .privately .btn.default-btn:hover {
        color: #fff;
        background-color: #00ccad;
        border-color: #00ccad;
    }

    .privately .question-char {
        border-radius: 50%;
        border: 5px solid #fff;
        width: 60px;
        height: 60px;
        line-height: 55px;
        background-color: transparent;
        font-weight: bold;
        font-size: 46px;
        color: #fff;
        text-align: center;
        cursor: pointer;
        transition: all .3s;
        position: relative;
        z-index: 2;
    }

    .privately .question-char:hover {
        background-color: #fff;
        color: #20b28d;
        border-color: #fff;
    }

    .privately h2 {
        font-size: 28px;
        margin-bottom: 8px;
    }

    .privately .details-table .btn {
        padding: 5px 15px;
        border-radius: 20px;
        background-color: #0fa181;
        color: #fff;
    }

    .privately .details-table .btn:hover {
        color: #fff;
        background-color: #00ccad;
        border-color: #00ccad;
    }

    /*
    *****************************
        safely
    *****************************
    */

    .safely body {
        --theme-color: #0179b5;
    }

    .safely > div.container > .main {
        border-radius: 12px;
    }

    .safely .btn.checked-btn {
        background-color: #5cc159;
    }

    .safely .btn.checked-btn:hover {
        color: #5cc159;
        border-color: #5cc159;
        background-color: #fff;
    }

    .safely .btn.default-btn {
        background-color: #03a9f4;
    }

    .safely .btn.default-btn:hover .corner-arrow {
        border-color: #03a9f4;
    }

    .safely .btn.default-btn:hover {
        color: #03a9f4;
        border-color: #03a9f4;
        background-color: #fff;
    }

    /*
    *****************************
        online-tools
    *****************************
    */

    .onlinetools {
        color: #243665;
    }

    .onlinetools .main {
        border-radius: 12px;
    }

    .onlinetools .btn.default-btn {
        background-color: #2196F3;
        font-weight: 600;
    }

    .onlinetools .btn.default-btn:hover {
        color: #ffffff;
        border: 2px solid #243665;
        background-color: #8BD8BD;
    }

    .onlinetools .btn.details-btn:hover {
        color: #ffffff;
        border: 2px solid #243665;
        background-color: #8BD8BD;
    }

    .onlinetools .btn.checked-btn {
        background-color: #8BD8BD;
        font-weight: 600;
    }

    .onlinetools .btn.checked-btn:hover {
        color: #ffffff;
        border: 2px solid #8BD8BD;
        background-color: #243665;
    }

    .onlinetools .btn.details-btn {
        background-color: #2196F3;
    }

    .onlinetools .btn.details-btn .details-text {
        font-weight: 600;
    }

    .onlinetools .btn.btn-reverse {
        background-color: #2196F3;
        font-weight: 600;
        color: white;
        border-radius: 20px;
        line-height: 1px;
    }

    .onlinetools .btn.btn-reverse:hover {
        color: #ffffff;
        border: 2px solid #243665;
        background-color: #8BD8BD;
    }


</style>
